import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IQitafGenerateOtpPayload } from '../../../entity/interface/iEntitlements';

export interface IQitafGenerateOtpUseCase {
    execute(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafGenerateOtpPayload,
        apiToken: { [key: string]: string },
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any>;
}

export class QitafGenerateOtpUseCase implements IQitafGenerateOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafGenerateOtpPayload,
        apiToken: { [key: string]: string },
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any> {
        return await this.subscriptionRepository.qitafGenerateOtp(
            subType,
            language,
            payload,
            apiToken,
            identityToken,
            token
        );
    }
}
